<template>
  <el-form-item :label="label" :prop="field">
    <el-radio-group
      v-if="inputType === 'radio'" 
      v-bind:value="value"
      v-on:input="check"
    >
      <el-radio :disabled="isReadOnly" v-for="(item, index) in valueRadio" :key="index" :label="item"></el-radio>
    </el-radio-group>
    <el-date-picker
      v-else-if="inputType === 'date'"
      :readonly="isReadOnly"
      :clearable="false"
      type="date"
      placeholder="Pick a Date"
      format="dd/MMM/yyyy"
      v-bind:value="value"
      v-on:input="check"
    >
    </el-date-picker>
    <el-input
      v-else
      :readonly="isReadOnly"
      :type="inputType"
      :spellcheck="false"
      :placeholder="placeholder"
      v-bind:value="value"
      v-on:input="check"
    ></el-input>
  </el-form-item>
</template>

<script>
export default {
  name: 'Input_Component',
  props: {
    value: [String, Date],
    label: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      defaut: 'text'
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    valueRadio: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      // testValue: '',
    }
  },
  computed: {
    testValue: {
      get () {
        return this.$props.inputData
      },
      set (payload) {
        this.$props.inputData = payload
      }
    }
  },
  methods: {
    check (e) {
      this.$emit('input', e)
    },
    handleInput (val) {
      if (this.$props.inputType === 'date') {
        val = this.formatDate(val)
      }
      this.$emit('handleInput',
        {
          label: this.$props.field,
          value: val
        }
      )
    },
    setValue (val) {
      this.$data.value = val
    },
    formatDate (date) {
      let d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      let year = d.getFullYear()

      if (month.length < 2) {
        month = '0' + month
      }
      if (day.length < 2) {
        day = '0' + day
      }
      
      return [year, month, day].join('-');
    }
  },
  watch: {
    value (val) {
      this.handleInput(val)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
